import "./_team.js";
import "./_agenda.js";
import "./_navscroll.js";

var blazy = new Blazy({loadInvisible: true});

function getTimeRemaining(timetoend) {
  var t = timetoend-(3600000);
  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor(t / (1000 * 60 * 60 * 24));
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

function makeid()
{
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for( var i=0; i < 5; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}


function initializeClock(id, timetoend) {
  var clock = document.getElementById(id);
  var daysSpan = clock.querySelector('.days');
  var hoursSpan = clock.querySelector('.hours');
  var minutesSpan = clock.querySelector('.minutes');
//  var secondsSpan = clock.querySelector('.seconds');

  function updateClock() {
    var t = getTimeRemaining(timetoend);

    daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
//    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }

  updateClock();
  var timeinterval = setInterval(updateClock, 1000);
}

jQuery(function($){

  function goTo(target, duration)
  {
    duration = 1000 || speed;
    target = target.length ? target : target.first();
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - $('#main-nav').height() - 20
      },  duration );
      return false;
    }
  }

  $(document).ready(function(){

     $('.the-timer').each(function(){
  	  var thisId = makeid();
  	  $(this).prop('id', thisId);

      initializeClock(thisId, $(this).attr('data-timetoend')*1000);

     })

     $('.gallery').owlCarousel({

      autoplay: true,
      autoplayTimeout: 5000,
      loop: true,
      autoplaySpeed: 800,
      singleItem: true,

      // breakpoint from 768 up

      responsive : {
        0 : {
          dots: true,
          dotsEach: 6,
          //  autoHeight: false,
          //  autoWidth:true,
           center:true,
           items: 1,
          //  pagination:true,
       },

       768 : {
          dots: true,
          dotsEach: 2,
          //  autoHeight: false,
          //  autoWidth:true,
           center:true,
           items: 1,
          //  pagination:true,
       }
     }
    })
  })
})



// accordian js


// var myAccordion = new Accordion('.accordion-container');

var accordion = new Accordion('.accordion-container',{

  // hides all answers
  hideAll: false,

  // shows all answers
  showAll: false,

  // shows the first answer
  showFirst: false,

  // panel ID you want to show at first time
  panelId: null

});

